import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  HostListener,
} from '@angular/core';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { AlertService } from '../../_alert';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import moment from 'moment';
import { DatastoreService } from '../../services/datastore.service';
import { CalendarService } from '../../services/calendar.service';
import { DateAdapter } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DepartmentService } from '../../services/jrni/department.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { async } from 'rxjs';
import { ServicesService } from '../../services/jrni/services.service';
import { ApiService } from '../../services/jrni/api.service';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'app-mat-calendar',
  templateUrl: './mat-calendar.component.html',
  styleUrls: ['./mat-calendar.component.scss'],
})
export class MatCalendarComponent implements OnInit {
  private core = AppConfig.settings.core;
  minDate;
  maxDate;
  selectedDate: Date;
  currentDate: Date;
  facilities: any;
  slots: any[] = [];
  selectedSlot;
  endTime;
  availableDays: any;
  selectedLocation: any;
  adminJourney: any;
  tempSlots: any;
  adminToggleDateRestrictions = false;
  startDate: any;
  calendarView: any;
  blAvailabilityRule = 55; // changed from 56
  blAvailabilityRuleBackup: any;
  @Input() service: any;
  @Input() location: any;
  @Input() component: any;
  @Input() slot: any;
  @Input() date: Date;
  @Output() selectSlotUpdate = new EventEmitter<any>();
  @ViewChild('calendar', { static: false }) calendar: MatCalendar<Date>;

  facilityForm = new UntypedFormGroup({
    selectedFacility: new UntypedFormControl(''),
  });
  selectedResource: any;
  resources: any[];
  showFa: boolean = false;
  showCalendar: boolean = false;

  constructor(
    private availabilityService: AvailabilityService,
    private alertService: AlertService,
    public translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private datastoreService: DatastoreService,
    private apiService: ApiService,
    private calendarService: CalendarService,
    private departmentService: DepartmentService,
    private dateAdapter: DateAdapter<Date>
  ) { }

  ngOnInit() {
    this.blAvailabilityRuleBackup = this.blAvailabilityRule;
    this.spinner.show();
    this.adminJourney = this.datastoreService.adminJourney;
    this.prepareDates();
    this.location.$getResources().then(async (res) => {
      if (this.datastoreService.selectedSuggestion) {
        this.selectedResource =
          this.datastoreService.selectedSuggestion.resource_id;
        this.availabilityService.setSelectedResourceObj(
          this.datastoreService.selectedSuggestion
        );
      }
      const services = await this.service.$getChildServices();
      const childService = services.find(
        (service) => service.company_id === this.location.id
      );
      const service: any = await this.apiService.getServiceByAdmin(
        this.core.company_id,
        this.location,
        childService.id,
        this.selectedResource
      );

      let serviceType;
      if (service.booking_type_public == 'booking') {
        serviceType = 4;
      } else {
        serviceType = 2;
      }
      this.datastoreService.serviceBookingType = serviceType;

      let resources = [];
      for (let resource_id of service.resource_ids) {
        for (let resource of res) {
          if (resource.id.toString() === resource_id.toString()) {
            resources.push(resource);
          }
        }
      }
      // const res2 = await this.location.$getResources()
      // console.log(res2)
      resources = resources.sort((a, b) => (a.name > b.name ? 1 : -1));
      this.resources = resources;
      this.facilities = resources;
      if (this.datastoreService.selectedSuggestion) {
        // auto selection from searched location/resource
        this.autoSetResource();
      } else {
        this.showFa = true;
        this.spinner.hide();
      }
    });
  }

  async reRun(fromToggle: boolean = false) {
    if (fromToggle) {
      this.adminToggleDateRestrictions = !this.adminToggleDateRestrictions;
      this.spinner.show();
    }
    if (this.adminToggleDateRestrictions) {
      this.blAvailabilityRule = 0;
    } else {
      this.blAvailabilityRule = this.blAvailabilityRuleBackup;
    }

    this.prepareDates();
    // this.onChangeFacility();

    const start = moment().startOf('month').format('YYYY-MM-DD');
    this.slots = [];
    this.tempSlots = [];
    this.startDate = start;
    this.availableDays = undefined;
    this.newCalendarRun(start);
  }

  doCalendarInit(resourceId: any = null) {
    this.spinner.show();
    // Set the current date to today for the calendar to default to today

    this.translateService.onLangChange.subscribe(async (event) => {
      this.dateAdapter.setLocale(event.lang);
      this.prepareDates();
      await this.newCalendarRun(
        this.service.min_advance_datetime.add(this.blAvailabilityRule, 'days')
      );
      if (this.slot) {
        this.selectSlot(this.slot);
      }
    });

    this.calendarService.onLocationChange.subscribe(async (location) => {
      this.location = location;
      await this.newCalendarRun(
        this.service.min_advance_datetime.add(this.blAvailabilityRule, 'days')
      );
      if (this.slot) {
        this.selectSlot(this.slot);
      }
      this.prepareDatesAfterUpdate();
    });

    this.prepareDates();

    (async () => {
      await this.newCalendarRun(
        this.service.min_advance_datetime.add(this.blAvailabilityRule, 'days')
      );
      if (this.slot) {
        this.selectSlot(this.slot);
      }
    })();
  }

  prepareDates() {
    this.currentDate = new Date();
    if (!this.selectedDate) {
      this.selectedDate = this.currentDate;
    }
    if (this.date) {
      this.selectedDate = this.date;
    }

    // Set max date as yesterday so the user cannot select a date until
    let minAdvTime = moment().add(this.blAvailabilityRule, 'days').toDate();
    console.log(minAdvTime);
    if (this.adminToggleDateRestrictions) {
      minAdvTime = new Date(this.service.min_advance_datetime);
    }
    this.minDate = moment(minAdvTime);
    this.maxDate = new Date(this.service.max_advance_datetime);
  }

  prepareDatesAfterUpdate() {
    // Set max date as yesterday so the user cannot select a date until
    const minAdvTime = new Date(this.service.min_advance_datetime);
    // back office is set to 16 minutes, we need 20 minutes so add 4 minutes onto it
    this.minDate = moment(minAdvTime).add(4, 'm').toDate();
    this.maxDate = new Date(this.service.max_advance_datetime);
  }

  async calendarRun(resourceId: any = null) {
    this.location.$getResources().then(async (res) => {
      const services = await this.service.$getChildServices();
      const childService = services.find(
        (service) => service.company_id === this.location.id
      );
      const service: any = await this.apiService.getServiceByAdmin(
        this.core.company_id,
        this.location,
        childService.id,
        resourceId
      );

      let resources = [];
      for (let resource_id of service.resource_ids) {
        for (let resource of res) {
          if (resource.id.toString() === resource_id.toString()) {
            resources.push(resource);
          }
        }
      }
      // const res2 = await this.location.$getResources()
      console.log(JSON.parse(JSON.stringify(resources)));
      resources = resources.sort((a, b) => (a.name > b.name ? 1 : -1));
      console.log(JSON.parse(JSON.stringify(resources)));
      this.resources = resources;
      this.facilities = resources;

      if (!this.datastoreService.selectedSuggestion) {
        this.showFa = true;
      }

      await this.getDays();

      // If the selected date has been store in datastore then pre populate the selection
      if (this.datastoreService.selectedDate) {
        let slotDate = new Date();
        if (this.datastoreService.selectedSlot.hasOwnProperty('start')) {
          slotDate = this.datastoreService.selectedSlot.start;
        } else {
          slotDate = this.datastoreService.selectedSlot;
        }
        await this.updateSlots(new Date(slotDate));
        this.selectedSlot = this.datastoreService.selectedSlot;
      } else {
        if (this.availableDays && this.availableDays.length > 0) {
          await this.updateSlots(new Date(this.availableDays[0].start_date));
        } else {
          await this.updateSlots(new Date());
        }
      }
      if (this.slots.length > 0) {
        this.selectSlot(this.slots[0]);
      }
      this.spinner.hide();
    });
  }

  async getDays() {
    let serviceAvailability;
    this.slots = [];
    this.selectedDate = undefined;
    if (typeof this.minDate === 'undefined') {
      this.prepareDates();
    }
    // Get the available times for a service
    const params = {
      company_id: this.location.id,
      date: this.minDate.toISOString().split('T')[0],
      edate: this.maxDate.toISOString().split('T')[0],
    };
    if (this.selectedResource) {
      params['resource_id'] = this.selectedResource;
    }
    // if (this.component) {
    //   serviceAvailability = await this.availabilityService.requestAvailableDays(this.location, this.service, params);
    // } else {
    //   serviceAvailability = await this.availabilityService.requestAvailableDaysService(this.location, this.service, params);
    // }
    const services = await this.service.$getChildServices();
    const childService = services.find(
      (service) => service.company_id === this.location.id
    );

    let useGeneratedDays = false;
    console.warn(`Generating synthetic days ${params.date} - ${params.edate}`);
    if (useGeneratedDays) {
      const start = new Date(params.date);
      const end = new Date(params.edate);

      const result = {
        _embedded: {
          day_data: [],
        },
        days: [],
        _links: {},
      };

      // Iterate through each day from start to end date
      for (
        let currentDate = new Date(start);
        currentDate <= end;
        currentDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000)
      ) {
        const formattedDate = currentDate.toISOString().split('T')[0];
        result.days.push({
          spaces: 100,
          date: formattedDate,
          fully_booked: false,
        });
      }

      serviceAvailability = result;
    } else {
      serviceAvailability = await this.apiService.getTimes(
        this.location.id,
        childService.id,
        params.date,
        params.edate,
        this.selectedResource,
        20
      );
    }

    // API filtering is currently not happening for days in the past so
    // the below code takes in the start and end date and filters the days before and after
    // to show correct availability. EMS-510 - 29/07/24
    let startDate = moment(params.date);
    let endDate = moment(params.edate);
    if (!serviceAvailability.days && serviceAvailability.dates) {
      serviceAvailability.days = serviceAvailability.dates;
    }
    let removePastDates = [];
    if (serviceAvailability.days && !serviceAvailability.dates) {
      serviceAvailability.dates = serviceAvailability.days;
      for (let d of serviceAvailability.dates) {
        d.available = !d.fully_booked;
        d.start_date = moment(d.date).format();
      }
    }
    removePastDates = serviceAvailability.dates.filter((dateObj: any) => {
      if (moment(dateObj.start_date).subtract(1, 'days').isBefore(startDate)) {
        return false;
      }
      if (moment(dateObj.start_date).isAfter(endDate)) {
        return false;
      }
      return true;
    });

    serviceAvailability.dates = removePastDates;

    // Set the available times so we do have to keep sending the same request
    await this.availabilityService.setAvailableDays(serviceAvailability.dates);

    // If service availability contains data then filter the days that are available
    if (serviceAvailability.dates && serviceAvailability.dates.length > 0) {
      // Get the available days
      this.availableDays = serviceAvailability.dates.filter(
        (day) => day.available == true
      );
    } else {
      this.alertService.error(
        this.translateService.instant('COMMON.NO_AVAILABILITY')
      );
    }
    return serviceAvailability;
  }

  // Check if the date is unavailable and if so return false
  // unavailableDates = (date: Date): boolean => {
  //   const momentDate = moment(date);
  //   if (momentDate.isBefore(this.minDate) || momentDate.isAfter(moment(this.maxDate))) {
  //     return false
  //   }
  //   if (this.availableDays) {
  //     return this.availableDays.some(day => momentDate.isSame(day.start_date)); // //
  //   } else {
  //     return false;
  //   }
  // }

  async onChangeFacility() {
    // resource dropdown
    await this.doCalendarInit();
    this.selectedResource =
      this.facilityForm.controls.selectedFacility.value != ''
        ? parseInt(this.facilityForm.controls.selectedFacility.value)
        : '';
    this.availabilityService.setSelectedResource(this.selectedResource);

    let selectedResourceObject = this.resources.filter(
      (resource) => resource.id == this.selectedResource
    );
    if (selectedResourceObject) {
      this.availabilityService.setSelectedResourceObj(
        selectedResourceObject[0]
      );
    }

    this.showCalendar = true;
  }

  async autoSetResource() {
    let selectedResourceObject = this.resources.filter(
      (resource) =>
        resource.id ==
        Number(this.datastoreService.selectedSuggestion.resource_id)
    );
    this.availabilityService.setSelectedResource(
      selectedResourceObject[0]['id']
    );
    await this.doCalendarInit(selectedResourceObject[0]['id']);
    console.log(
      `auto selected ${selectedResourceObject[0].id} ${selectedResourceObject[0].name}`
    );
    if (selectedResourceObject) {
      this.availabilityService.setSelectedResourceObj(
        selectedResourceObject[0]
      );
      this.showCalendar = true;
      this.showFa = false;
    } else {
      console.log(`Couldnt auto selected - falling back to user selection`);
      this.showFa = true;
    }
  }

  // RPD-119: keep the earliest slot the customer was offered. The calendar loads the first
  // open day itself, so take the value from that first load and ignore later day clicks.
  // A new service, location or venue starts again.
  private recordFirstSlot() {
    const key = `${this.service?.id}:${this.location?.id}:${this.selectedResource}`;
    if (this.slots[0] && this.datastoreService.firstSlotAnalyticKey !== key) {
      this.datastoreService.firstSlotAnalytic = this.slots[0].start;
      this.datastoreService.firstSlotAnalyticKey = key;
    }
  }

  // Date selected on calendar
  async updateSlots(date) {
    this.spinner.show();
    // add two hours onto the date so when we convert with iso it always keeps the same date
    date.setHours(date.getHours() + 2);

    // Update the selected date
    this.selectedDate = date;

    // slice time off
    const isoTime = date.toISOString().slice(0, -1).split('T')[0];

    this.service.calculated_duration =
      Number(this.datastoreService.extraDuration) +
      Number(this.service.durations[0]);

    const params = {
      service_id: this.service.id,
      start_date: isoTime,
      end_date: isoTime,
      duration: this.service.calculated_duration,
    };

    if (this.selectedResource) {
      params['resource_id'] = this.selectedResource;
    }
    // let wheelChairAccess = false;

    // if (this.datastoreService.companyQuestionsForm) {
    //   wheelChairAccess = this.datastoreService.companyQuestionsForm.controls[277].value.toLowerCase().includes("yes") ? true : false;
    // }

    // Only add slots with availability
    const res = await this.availabilityService.getSlots(this.location, params);
    this.slots = [];
    if (res) {
      // if (wheelChairAccess) {
      // @TODO - rework this using a slot call per resource
      // const wcLocations = this.departmentService.getAccessibleLocations();
      // for (let staff of res['_embedded'].events) {
      //   let staffEvents = [];
      //   if (wcLocations.length > 0) {
      //     for (let l of wcLocations) {
      //       if (l.id == staff.resource_id) {
      //         staffEvents = staff.times;
      //       }
      //     }
      //   }
      //   staff.times = staffEvents;
      // }
      // }

      let setCalendarMonth = false;
      for (let time of res['times']) {
        if (time.available) {
          if (!setCalendarMonth) {
            setCalendarMonth = true;
            this.calendar._goToDateInView(this.selectedDate, 'month');
          }
          this.slots.push(time);
        }
      }

      // give all timeslots a london timezone and sort
      this.slots = this.slots.map(slot => ({
        ...slot,
        displayTime: moment
          .utc(slot.start)
          .tz('Europe/London')
          .format('HH:mm'),
      }));

      this.slots.sort((a, b) => a.time - b.time);
    }

    // Remove dupes from different staff
    this.slots = this.slots.filter(
      (slot, index, self) =>
        index === self.findIndex((t) => t.start === slot.start)
    );

    // Remove slots if they are past the minDate (20 minutes before any booking)
    this.slots = this.slots.filter((x) => new Date(x.start) > this.minDate);
    this.recordFirstSlot();
    this.spinner.hide();
  }

  // Set the slot
  // selectSlot(slot) {
  //   this.selectedSlot = slot;
  //   this.availabilityService.selectedResource = this.selectedResource
  //   console.log(slot)
  //   this.availabilityService.setSelectedSlot(slot);
  //   this.selectSlotUpdate.emit(slot);
  //   // set end slot time
  //   var endSlot = slot.start;
  //   this.endTime = moment(endSlot).add(30, 'm').toDate();
  //   this.availabilityService.setEndSlot(this.endTime)
  // }

  getDateRange(date) {
    const startDate = moment(date).startOf('month').format('YYYY-MM-DD hh:mm');
    const endDate = moment(date).endOf('month').format('YYYY-MM-DD hh:mm');
    return {
      startDate,
      endDate,
    };
  }

  // Set the slot
  selectSlot(slot) {
    slot.datetime = moment(slot.start).format('YYYY-MM-DDTHH:mm:ss');
    this.selectedSlot = slot;
    this.availabilityService.setSelectedSlot(slot);
    this.selectSlotUpdate.emit(true);
  }

  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.calendarView = this.calendar['_currentView'];

    // get the clicked element
    if (event.target.offsetParent) {
      if (
        (event.target.offsetParent.ariaLabel &&
          event.target.offsetParent.ariaLabel.includes('Previous month')) ||
        (event.target.offsetParent.ariaLabel &&
          event.target.offsetParent.ariaLabel.includes('Next month'))
      ) {
        this.spinner.show();
        const startOfMonth = moment(this.calendar.activeDate)
          .startOf('month')
          .format('YYYY-MM-DD');
        this.slots = [];
        this.tempSlots = [];
        this.startDate = startOfMonth;
        this.availableDays = undefined;
        this.newCalendarRun(startOfMonth);
      }
    }

    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    // if event.target.innerHTML is one of the months in the array
    if (months.includes(event.target.innerHTML.trim())) {
      this.spinner.show();
      const startOfMonth = moment(this.calendar.activeDate)
        .startOf('month')
        .format('YYYY-MM-DD');
      this.slots = [];
      this.tempSlots = [];
      this.startDate = startOfMonth;
      this.availableDays = undefined;
      this.newCalendarRun(startOfMonth);
    }
  }

  // Check if the date is unavailable and if so return false
  unavailableDates = (date: Date): boolean => {
    const isMultiYearView = this.isMultiYearView();

    if (isMultiYearView) {
      // If the date is in the past, disable it
      if (date < new Date()) {
        return false;
      } else {
        return true;
      }
    } else {
      // if the date is less than blAvailabilityRule days away, disable them
      const maxDate = moment().add(this.getMaxDate(), 'days');
      if (moment(date).isBefore(maxDate)) {
        return false;
      }

      // finally check if the day is available
      const momentDate = moment(date);
      if (this.availableDays) {
        return this.availableDays.some((day) => momentDate.isSame(day.date));
      } else {
        return false;
      }
    }
  };

  getMaxDate() {
    return this.blAvailabilityRule;
  }

  isMultiYearView(): boolean {
    if (!this.calendar) {
      return false;
    }
    return this.calendar['_currentView'] === 'multi-year' ||
      this.calendar['_currentView'] === 'year'
      ? true
      : false;
  }

  async newUpdateSlots(date) {
    this.slots = [];
    // Update the selected date
    this.selectedDate = date;
    this.slots = this.tempSlots.filter((slot) => {
      let slotDate = moment(slot.start).format('YYYY-MM-DD');
      let selectedDate = moment(date).format('YYYY-MM-DD');
      if (slotDate == selectedDate) {
        return slot;
      }
    });

    // give all timeslots a london timezone and sort
    this.slots = this.slots.map(slot => ({
      ...slot,
      displayTime: moment
        .utc(slot.start)
        .tz('Europe/London')
        .format('HH:mm'),
    }));

    // Sort from earliest to latest time
    this.slots.sort((a, b) => a.time - b.time);
    console.log(this.calendar);
    this.recordFirstSlot();
    this.spinner.hide();
  }

  // new cal stuff
  async newCalendarRun(date) {
    // get the start time of the month selected
    const dateRange = this.getDateRange(date);
    const params = {
      service_id: this.service.id,
      start_date: dateRange.startDate,
      end_date: dateRange.endDate,
    };

    this.service.calculated_duration =
      Number(this.datastoreService.extraDuration) +
      Number(this.service.durations[0]);

    this.apiService
      .getTimes(
        this.location.id,
        this.service.id,
        dateRange.startDate,
        dateRange.endDate,
        this.selectedResource,
        this.service.calculated_duration
      )
      .then(async (res: any) => {
        let days = [];
        this.tempSlots = [];
        res.times.forEach((timeslot) => {
          if (timeslot.available) {
            this.tempSlots.push(timeslot);
          }
        });
        // work out days from the tempSlots
        this.tempSlots.forEach((slot) => {
          let formatedDate = moment(slot.start).format('YYYY-MM-DD');
          let found = days.find((daysDate) => daysDate.date == formatedDate);
          if (found) {
            found.spaces = found.spaces + 1;
          } else {
            days.push({ spaces: 0, date: formatedDate });
          }
        });
        await this.availabilityService.setAvailableDays(days);

        // filter days that are within set days from today
        let today = moment()
          .add(this.blAvailabilityRule, 'days')
          .format('YYYY-MM-DD');
        days = days.filter((day) => moment(day.date).isAfter(today));

        // if there is no days left, we need to re run the calendar function to look at the next month until we find days
        if (days.length == 0) {
          console.log(
            `No days found, looking at next month - ${dateRange.startDate} - ${dateRange.endDate}`
          );
          if (moment(this.service.max_advance_datetime).isAfter(moment(dateRange.endDate))) {
            let nextMonth = moment(date)
              .add(1, 'months')
              .startOf('month')
              .format('YYYY-MM-DD');
            this.newCalendarRun(nextMonth);
            return;
          }
        } else {
          this.startDate = new Date(days[0].date); // our start date to the first date you can book
        }

        this.availableDays = days;
        if (days && days.length > 0) {
          this.newUpdateSlots(new Date(days[0].date));
        } else {
          this.newUpdateSlots(new Date());
        }
      });
  }
}
